import { Link, useLocation } from 'react-router-dom';
import Navigation from '@/components/feature/Navigation';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Navigation />
      <main className="relative z-10 pt-24 pb-16 flex-1">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <section className="relative overflow-hidden rounded-3xl border border-red-900/40 bg-gradient-to-br from-black via-[#130202] to-black p-8 md:p-12 shadow-2xl shadow-red-950/30">
              <div className="absolute inset-0 opacity-25" style={{ backgroundImage: 'radial-gradient(circle at 15% 15%, rgba(220,38,38,0.28), transparent 25%), radial-gradient(circle at 85% 20%, rgba(220,38,38,0.18), transparent 22%), linear-gradient(135deg, transparent 0%, rgba(255,255,255,0.02) 50%, transparent 100%)' }} />
              <div className="relative">
                <div className="inline-flex items-center gap-2 rounded-full border border-red-800/50 bg-red-950/30 px-4 py-1.5 text-xs uppercase tracking-[0.3em] text-red-300">
                  <i className="ri-error-warning-line"></i>
                  Lost In The Fog
                </div>
                <div className="mt-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                  <div>
                    <p className="font-orbitron text-6xl md:text-8xl text-red-500 horror-heading glitch-subtle">404</p>
                    <h1 className="mt-3 text-3xl md:text-5xl font-bold font-orbitron text-white">
                      This corridor goes nowhere.
                    </h1>
                    <p className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-gray-300">
                      The route <span className="font-mono text-red-300">{location.pathname}</span> does not exist on the Uliunai KF1 site.
                    </p>
                  </div>
                  <div className="hidden md:flex h-28 w-28 items-center justify-center rounded-2xl border border-red-900/30 bg-black/40 text-red-500/60">
                    <i className="ri-skull-2-line text-5xl"></i>
                  </div>
                </div>

                <div className="mt-8 grid gap-3 sm:grid-cols-3">
                  <Link
                    to="/"
                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-red-600 px-5 py-3 font-semibold text-white transition-colors hover:bg-red-500"
                  >
                    <i className="ri-home-5-line"></i>
                    Back Home
                  </Link>
                  <Link
                    to="/download"
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-red-800/50 bg-black/40 px-5 py-3 font-semibold text-gray-100 transition-colors hover:bg-red-950/30"
                  >
                    <i className="ri-download-2-line"></i>
                    Downloads
                  </Link>
                  <Link
                    to="/stats"
                    className="inline-flex items-center justify-center gap-2 rounded-xl border border-red-800/50 bg-black/40 px-5 py-3 font-semibold text-gray-100 transition-colors hover:bg-red-950/30"
                  >
                    <i className="ri-bar-chart-grouped-line"></i>
                    Player Stats
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
